<div class="plans-page">
    <section class="plans-hero animate-fade-in-up" aria-label="Engagement Modalities">
        <div class="plans-hero__container">
            <div class="plans-hero__head">
                <div class="plans-hero__eyebrow">Engagement Modalities</div>
                <div class="plans-hero__title">Tailored AI Engineering Cells.</div>
                <div class="plans-hero__copy">
                    Flexible and highly scalable business models designed to integrate seamlessly into your enterprise
                    operational expenditure.
                </div>
            </div>

            <div class="plans-grid">
                <article class="plan-card">
                    <div class="plan-card__title">Dedicated</div>
                    <div class="plan-card__sub">Static Capacity</div>
                    <div class="plan-card__copy">
                        An exclusive, full-time AI engineering cell dedicated purely to your models. Provides highly
                        predictable capacity producing a static, easy-to-manage monthly operational burn rate.
                    </div>
                    <button type="button" class="plan-card__btn plan-card__btn--outline" (click)="openCalendlyPopup()">
                        Inquire Capacity
                    </button>
                </article>

                <article class="plan-card plan-card--featured">
                    <div class="plan-card__tag">Enterprise Standard</div>
                    <div class="plan-card__title">Hybrid</div>
                    <div class="plan-card__sub">Optimal Adoption</div>
                    <div class="plan-card__copy">
                        A precisely synchronized structure blending onsite, client-facing LLM architects with an
                        offshore execution engine. Delivers the perfect ratio of strategic oversight to cost-effective
                        model training.
                    </div>
                    <button type="button" class="plan-card__btn plan-card__btn--solid" (click)="openCalendlyPopup()">
                        Engage Architecture
                    </button>
                </article>

                <article class="plan-card">
                    <div class="plan-card__title">Shared</div>
                    <div class="plan-card__sub">Elastic Retainer</div>
                    <div class="plan-card__copy">
                        A deeply elastic model where data scientists are pooled and allocated dynamically via an ad-hoc
                        monthly retainer. Designed for ultimate structural flexibility based entirely on incoming data
                        volumes.
                    </div>
                    <button type="button" class="plan-card__btn plan-card__btn--outline" (click)="openCalendlyPopup()">
                        Inquire Elasticity
                    </button>
                </article>
            </div>
        </div>
    </section>

    <!-- <section id="contact" class="contact-section" aria-label="Contact Us">
        <div class="contact-section__container">
            <div class="contact-section__grid">
                <div>
                    <div class="contact-section__eyebrow">Connect</div>
                    <div class="contact-section__title">Discover the future of applied AI.</div>
                    <div class="contact-section__copy">
                        Connect with our delivery experts to audit your topology and map your enterprise integration
                        roadmap.
                    </div>
                </div>

                <div class="contact-card">
                    <div class="contact-card__corner" aria-hidden="true"></div>
                    <div class="contact-card__title">Direct Inquiry</div>

                    <div *ngIf="submitted" role="alert" class="contact-card__success animate-fade-in-up">
                        <svg viewBox="0 0 24 24" aria-hidden="true">
                            <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                        <div>Request securely logged. Our architecture team will reach out within one business day.
                        </div>
                    </div>

                    <form *ngIf="!submitted" [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="contact-form">
                        <div class="contact-form__field">
                            <input type="text" formControlName="name" placeholder="Full Name" />
                        </div>

                        <div class="contact-form__row">
                            <div class="contact-form__field">
                                <input type="email" formControlName="email" placeholder="Corporate Email" />
                            </div>
                            <div class="contact-form__field">
                                <input type="text" formControlName="company" placeholder="Organization" />
                            </div>
                        </div>

                        <div class="contact-form__field">
                            <textarea rows="3" formControlName="message"
                                placeholder="Brief context of operational challenges..."></textarea>
                        </div>

                        <button type="submit" [disabled]="contactForm.invalid || isSubmitting"
                            class="contact-form__submit">
                            <span *ngIf="!isSubmitting">Transmit Request</span>
                            <span *ngIf="isSubmitting" class="contact-form__submit-loading">
                                <svg viewBox="0 0 24 24" aria-hidden="true">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <path d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                                </svg>
                                Encrypting...
                            </span>
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </section> -->
</div>